var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaxResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fax_svgrepo-com",
    "data-name": "Fax svgrepo-com",
    d: "M18,17V14.01A4,4,0,0,0,14,10H11v5L5,9l6-6V8h3a6,6,0,0,1,6,6v3ZM6,6V3L0,9l6,6V12L3,9Z",
    transform: "translate(0 -3)",
    fill: "#3b71ca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaxResend);
export default __webpack_public_path__ + "static/media/FaxResend.68df40f37cbbb8765301be713d4a6bcb.svg";
export { ForwardRef as ReactComponent };